import React, { useEffect, useState } from "react";
import { DashboardLayout, FormParser, PopupModal } from "../Components";
import { NavLink, useParams } from "react-router-dom";
import Masters from "../Components/masters.json"
import "./Pages.css"
import axiosConfig from "../Service/axiosConfig"
import sidebarData from "../Components/DashboardLayout/sidebar";

const ClinicAddressEdit = () => {
    const [Error, SetError] = useState("")
    const [popupType, setpopupType] = useState("")
    const [activeState, setActiveState] = useState("")
    const sidebarDatavalue = sidebarData.clinicProfile
    const [ChildNavs, SetChildNavs] = useState("")
    const MastersModal = Masters.ClinicAddress
    const formSubmit = (Data) => {
        axiosConfig.post(`/clinics/clinicaddress/`, {
            "address": Data.address,
            "pincode": Data.pincode,
            "city": Data.city,
            "gps_coordinates": Data.gps_coordinates, clinic: id
        }).then(res => {
            console.log(res)
            setpopupType("success")
        }).catch(error => {
            console.log(error)
            let ErrorData = []
            ErrorData.push({
                code: error.response.data.code || ["null"],
                name: error.response.data.name || ["null"],
            })
            console.log(ErrorData[0])
            if (ErrorData[0].code[0] === "This field must be unique.") {
                SetError("Code Already Exists")
            }
            if (ErrorData[0].name[0] === "This field must be unique.") {
                SetError("Name Already Exists")
            }
            setpopupType("error")
        })
    }
    let { id } = useParams();
    const [Data, SetData] = useState([])
    const GetData = async () => {
        try {
            const responce = await axiosConfig.get(`/clinics/clientaddress/${id}/`)
            SetData(responce.data)
        }
        catch (error) {
            console.log(error)

        }

    }
    const currentURL = window.location.href;

    const OnChildNavClicked = (path) => {
        SetChildNavs(path)
        localStorage.setItem("url", path)

    }
    
    useEffect(() => {
        GetData();
        SetChildNavs(localStorage.getItem("url"))
    }, [])
    return (
        <>
            <DashboardLayout>
                <div className="mainbar">
                    <div className="sidebar-filters px-2">
                        {
                            sidebarDatavalue.map((childItem, index) => {
                                return (
                                    <div key={index}>
                                        <h5>{childItem.SubTitle}</h5>
                                        {
                                            childItem.NavItems.map((item, idx) => {
                                                return (
                                                    <div key={idx} className={ChildNavs == item.path ? "Configiration-list active" : "Configiration-list"}>
                                                        <NavLink to={item.path} className={ChildNavs == item.path ? "colorChange" : "NoColorChange"} onClick={() => OnChildNavClicked(item.path)}>
                                                            <span className="configiration-icon">{item.icon}</span>
                                                            <span className="list-name">{item.label}</span>
                                                        </NavLink>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="main-code">
                        <div className="dashboard-header">
                            <h5 className="dashboard-subtitle">Clinic Address{id}</h5>
                        </div>
                        <FormParser modelObject={MastersModal} formData={Data} formSubmit={formSubmit} error={Error} />
                    </div>
                </div>
                {popupType != "" &&
                    <PopupModal popupType={popupType} Navigation="" />
                }
            </DashboardLayout>
        </>
    )

}
export { ClinicAddressEdit }